<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal' && showSlider">
    <div cvModuleCxoneCustomSettingSection after="rec" class="planStatusSettings gridItemSettingsPanelCustomSettingsBottomItem mb-5" [moduleManager]="moduleManager">
        <div class="custom-setting-section-title">
            <span class="cxone-section-header" cvLocalizedText langSection="Plans_Status_Module" langKey="Additional_Filters">Additional Filters</span>
        </div>
        <div class="custom-setting-section-body mb-3">
            <cv-reportingset-dynamic-filters-wrapper 
                [moduleManager]="moduleManager"
                [reportingSetDefinitions]="['Filterable Test', 'Hierarchy Selector Test']">
            </cv-reportingset-dynamic-filters-wrapper>
        </div>
        <div class="form-group custom-setting-section-checkbox-automatic">
            <cxone-checkbox type="checkbox" [labelText]="getLocalizationString('Auto_Select', 'Auto-select plans by \'On-Track Status\'')" class="automatic-quality-plan-checkbox" [(ngModel)]="automaticQualityPlan"></cxone-checkbox>
        </div>
        <div class="custom-setting-section-title">
            <span class="cxone-section-header" cvLocalizedText langSection="Plans_Status_Module" langKey="OT_Threshold">ON-TRACK THRESHOLD</span>
        </div>
        <div class="custom-setting-section-body">
            <div class="d-flex flex-nowrap align-items-center">
                <cxone-range-slider class="w-100" [min]="0" [max]="100" [markerValues]="11" [(ngModel)]="range" [density]="2"
                                    [enableTooltipOnDrag]="true" [startPoints]="[0,1]" [connect]="[true,false,true]"
                                    [colorClasses]="['lowerConnect', 'upperConnect']"></cxone-range-slider>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="moduleManager.settingsView === 'slideout'">
    <cv-module-custom-setting-section class="planStatusSettings" [moduleManager]="moduleManager">
        <div class="custom-setting-section-title">
            <span cvLocalizedText langSection="Plans_Status_Module" langKey="OT_Threshold">ON-TRACK THRESHOLD</span>
        </div>
        <div class="custom-setting-section-body">
            <div class="d-flex flex-nowrap align-items-center">
                <cxone-range-slider class="w-100" [min]="0" [max]="100" [markerValues]="11" [(ngModel)]="range" [density]="2"
                                    [enableTooltip]="false" [startPoints]="[0,1]" [connect]="[true,false,true]"
                                    [colorClasses]="['lowerConnect', 'upperConnect']"></cxone-range-slider>
            </div>
        </div>
    </cv-module-custom-setting-section>
</ng-container>

<ng-container *ngIf="moduleManager.settingsView === 'modal'">
    <div cvModuleLegacyCustomSettingSection class="planStatusSettings gridItemSettingsPanelCustomSettingsBottomItem" [moduleManager]="moduleManager">
        <div class="custom-setting-section-title mt-1">
            <span cvLocalizedText langSection="Plans_Status_Module" langKey="Display_Name">DISPLAY NAME</span>
        </div>
        <div class="custom-setting-section-body">
            <div class="d-flex flex-column align-items-end">
                <cxone-text-input typeof="text" class="text-input w-100" [(ngModel)]="moduleManager.moduleOptions.editName"
                                  (keyup)="validateName($event)"></cxone-text-input>
                {{moduleManager.moduleOptions.editName?.length}}/{{nameMxSz}}
            </div>
        </div>
        <div class="custom-setting-section-title mt-3">
            <span cvLocalizedText langSection="Plans_Status_Module" langKey="OT_Threshold">ON-TRACK THRESHOLD</span>
        </div>
        <div class="custom-setting-section-body">
            <div class="d-flex flex-nowrap align-items-center">
                <cxone-range-slider class="w-100" [min]="0" [max]="100" [markerValues]="11" [(ngModel)]="range" [density]="2"
                                    [enableTooltip]="false" [startPoints]="[0,1]" [connect]="[true,false,true]"
                                    [colorClasses]="['lowerConnect', 'upperConnect']"></cxone-range-slider>
            </div>
        </div>
    </div>
</ng-container>

